import { Flex } from '@radix-ui/themes';
import { MachineFirmwareSection } from 'components/sections/admin-portal/machines/dialogs/settings/machine-status/machine-firmware-section';
import { MachineHardwareSection } from 'components/sections/admin-portal/machines/dialogs/settings/machine-status/machine-hardware-section';
import { MachineStateSection } from 'components/sections/admin-portal/machines/dialogs/settings/machine-status/machine-state-section';
import { MachineStatusSection } from 'components/sections/admin-portal/machines/dialogs/settings/machine-status/machine-status-section';
import { RADIX } from 'lib_ts/enums/radix-ui';

export const MachineStatus = () => (
  <Flex direction="column" gap={RADIX.FLEX.GAP.MD}>
    <MachineStatusSection />
    <MachineFirmwareSection />
    <MachineHardwareSection />
    <MachineStateSection />
  </Flex>
);
